export const _browserLanguage = (isChinese) => {
  const language = (
    navigator.browserLanguage || navigator.language
  ).toLowerCase();
  if (isChinese) {
    return language.indexOf("zh") > -1;
  } else {
    if (language.indexOf("zh") > -1) {
      return "zh";
    } else if (language.indexOf("en") > -1) {
      return "en";
    } else {
      return "other";
    }
  }
}

export const  getQueryString = (variable) => {
  let href = window.location.href
  let query = href.substring(href.indexOf('?') + 1)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}